import styled from 'styled-components';
import AddReviewBoxImage from "../../assests/images/get-badge/add-revie-box-bg.webp";

export const TopBannerSection = styled.section`
    width: 100%;
 @media screen and (max-width:767px){
      padding-top:50px;
  }
    form.search-header{
        display: none;
    }
 
    .base-small-text{
        display: block;
      }

    .base-color{
        display: block;
    }
    
    .review-search-group{
        display: none;
    }
`;

export const GetBadgeSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 50px 0px;

    @media screen and (max-width: 767px){
        padding: 40px 0px;
    }
`;

export const AddReviewSection = styled.section`
    padding-bottom: 50px;
    background: #fff;
    color: #000000;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 22px;

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 20px;
    }
`;

export const AddReviewTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-weight: 600;
    font-family: 'Jost', sans-serif;
    line-height: 44px;

    @media screen and (max-width: 991px){
        font-size: 28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size: 26px;
        line-height: 38px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const AddReviewText = styled.p`
    margin: 20px 0px 10px;
`;

export const AddReviewBox = styled.div`
    // background-image:url(${AddReviewBoxImage});
    background: transparent linear-gradient(329deg, #F7931E 0%, #33A7AE 100%) 0% 0% no-repeat padding-box;
    width: 100%;
    padding: 22px 24px;
    border-radius: 15px;
    margin-top: 10px;
    box-shadow: 0px 10px 30px #00000014;

    @media screen and (max-width: 991px){
        margin-top: 30px;
    }
    
    @media screen and (max-width: 767px){
        margin-top: 20px;
    }
`;
export const AddReviewBoxTitle = styled.h4`
    color: #FFFFFF;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 26px;
    text-align: center;
`;

export const AddReviewBoxSmall = styled.small`
    color: #FFFFFF;
    font-size: 14px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
    margin-bottom: 12px;
    display: block;
`;

export const AddReviewRating = styled.div`
    color: #fff;
    padding: 12px 0px;
    display: flex;
    justify-content: center;
    column-gap: 12px;
    
    span.RatingReview{
        color: #fff;
        font-weight: 400;
    }
`;

export const AddReviewImage = styled.div`
    max-width: 242px;

    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const AddReviewContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 5px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #FFFFFF;
`;

export const AddReviewContentText = styled.div`
    color: #FFFFFF;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 300;
    line-height: 26px;
`;

export const RecentReviewsMain = styled.div`

`;

export const RecentReviewsBox = styled.div`
    color: #fff;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 300;
    line-height: 24px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgb(255 255 255 / 20%);

    &:last-child{
        padding-bottom: 0px;
        border-bottom: none;
    }
`;


export const RecentReviewsTitle = styled.h4`
    color: #FFFFFF;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    margin-bottom: 8px;
`;

export const RecentReviewWrap = styled.div`
   width: 100%;
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-top: 5px;
`;

export const RecentReviewWrapTitle = styled.h4`
   color: #FFFFFF;
   font-size: 16px;
   font-family: 'Jost', sans-serif;
   font-weight: 600;
   line-height: 24px;
`;

export const RecentReviewWrapRating = styled.div`
    span.RatingReview {
        display: none;
    }
`;

export const RecentReviewWrapText = styled.div`

    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* number of lines to show */
    line-clamp: 3; 
   -webkit-box-orient: vertical;

`;

export const MoreReviewButton = styled.div`
    width: 100%;
    text-align: center;
    margin-top: 20px;

    .btn-outline-success-blue{
        padding: 12px 27px;
    }
`;

export const AddReViewCode = styled.div`
    width: 100%;
    padding: 25px 85px 25px 30px;
    margin-top: 25px;
    word-break: break-all;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 30px 20px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
    border-radius: 20px;
    box-shadow: 0px 20px 20px #0000001A;

    @media screen and (max-width: 991px){
        padding: 20px;
         border-radius: 15px;
    }
    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 24px;
    }
    
    &.mini-badge-code{
        background: #fff;
    }  
`;